import React from "react";
import { useLocationStore } from "../hooks/useLocationStore";
import "../assets/style/StudioSelector.css";

/**
 * StudioSelector — prominent card-based location switcher.
 * Only rendered when there are 2+ main locations.
 */
const StudioSelector = () => {
  const {
    mainLocations,
    selectedLocationId,
    setSelectedLocationId,
  } = useLocationStore((state) => ({
    mainLocations: state.mainLocations,
    selectedLocationId: state.selectedLocationId,
    setSelectedLocationId: state.setSelectedLocationId,
  }));

  // Only show when there are 2+ main locations
  if (mainLocations.length < 2) return null;

  return (
    <section className="studio-selector" id="studio-selector">
      <div className="container">
        <h3 className="studio-selector__heading">Nasze Studia</h3>
        <p className="studio-selector__subheading">
          Wybierz lokalizację, aby zobaczyć grafik i szczegóły
        </p>
        <div className="studio-selector__grid">
          {mainLocations.map((location) => {
            const isActive = selectedLocationId === location.id;
            return (
              <button
                key={location.id}
                className={`studio-selector__card ${
                  isActive ? "studio-selector__card--active" : ""
                }`}
                onClick={() => setSelectedLocationId(location.id)}
                aria-pressed={isActive}
              >
                <div className="studio-selector__card-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <div className="studio-selector__card-content">
                  <span className="studio-selector__card-name">
                    {location.timetable_name || location.name}
                  </span>
                  <span className="studio-selector__card-address">
                    {location.address}
                  </span>
                </div>
                {isActive && (
                  <div className="studio-selector__card-check">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StudioSelector;
